:host {
  .hide {
    display: none !important;
  }

  .error-unauthorized-modal {
    position: absolute;
    z-index: 4;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    top: 50%;
    width: 70%;

    .chat-message {
      border-radius: 0 10px 10px 10px;

      &__user {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        module-avatar-component,
        img,
        &--avatar {
          margin-right: 10px;
        }

        span {
          color: #333333;
          color: var(--font-primary);
          font-size: 15px;
          font-weight: 600;
        }

        &--avatar {
          border-radius: 50%;
          width: 20px;
          height: 20px;
          object-fit: contain;
        }

        img {
          border-radius: 50%;
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }

      &__message {
        margin-bottom: 10px;
        background-color: #fff;
        background-color: var(--bg-primary);
        padding: 20px 18px;
        border-radius: 0 10px 10px 10px;
        display: inline-block;
        width: auto;
        max-width: 100%;

        .message__text {
          color: #666666;
          color: var(--font-secondary);
          margin-bottom: 20px;
        }

        .message__actions {
          display: flex;
          flex-direction: column;
          justify-content: center;

          a {
            width: 100%;
            border: none;
            color: white;
            background: #0098ff;
            background: var(--blue);
            border-radius: 6px;
            padding: 10px 20px;
            margin-bottom: 10px;
            cursor: pointer;
            text-decoration: none;
            box-sizing: border-box;
            text-align: center;

            &:hover {
              transition: background 0.3s;
              background: #007ee2;
              background: var(--blue-hover);
              color: white;
            }
          }

          button {
            border: none;
            background: none;
            color: #0098ff;
            color: var(--blue);
            cursor: pointer;

            &:focus {
              outline: none;
            }

            &:disabled {
              background: rgba(0, 0, 0, 0.12);
              background: var(--bg-disabled-button);
              border: none;
              color: rgba(0, 0, 0, 0.26);
              color: var(--font-disabled);
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                FULL VERSION                                */
  /* -------------------------------------------------------------------------- */
  .error-unauthorized-modal--full {
    top: 30%;
    display: flex;
    justify-content: center;
    .chat-message__user {
      span {
        color: var(--bg-primary);
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    .error-unauthorized-modal {
      display: flex;
      justify-content: center;
      width: calc(100% - 40px);
    }
  }
}
